import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

//note, when you update language.json file, make sure that you update this version string, if not then the user will not get the updated version of language.json
const version = 'v20261013_flat';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: 'en',
    lng: 'vn',
    debug: true,
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${version}`,
    },

    interpolation: {
      escapeValue: false, // not needed for react!!
    },
  });
